export default __webpack_public_path__ + "static/bannerbox.ikb-152f58794f529d9d7b445b4cc773e75d.jpg";